// primary is in 500, secondary in 100
export const changeToLightTheme = () => {
  let root = document.documentElement;
  root.style.setProperty('--desktop-color', '#c2c2c2'); //secondary dark
  root.style.setProperty('--icon-font-color', '#000000'); //text on secondary
  root.style.setProperty('--app-background-color', '#ffffff'); //secondary light
  root.style.setProperty('--app-outline-color', '#494949'); //primary dark
  root.style.setProperty('--topbar-background-color', '#757575'); //primary
  root.style.setProperty('--topbar-font-color', '#ffffff'); //text on primary
  root.style.setProperty('--menubar-background-color', '#f5f5f5'); //secondary
  root.style.setProperty('--menubar-font-color', '#000000'); //text on secondary
  root.style.setProperty('--button-background-color', '#cfcfcf'); //secondary light
  root.style.setProperty('--button-highlight-color', '#f5f5f5'); //secondary
  root.style.setProperty('--button-font-color', '#000000'); //text on secondary
  root.style.setProperty('--button-outline-color', '#494949'); //primary dark
  root.style.setProperty('--taskbar-color', '#757575'); //primary
  sessionStorage.setItem('themeSelection.file', 'light');
}

export const changeToDarkTheme = () => {
  let root = document.documentElement;
  root.style.setProperty('--desktop-color', '#102027'); //secondary dark
  root.style.setProperty('--icon-font-color', '#ffffff'); //text on secondary
  root.style.setProperty('--app-background-color', '#62727b'); //secondary light
  root.style.setProperty('--app-outline-color', '#000a12'); //primary dark
  root.style.setProperty('--topbar-background-color', '#263238'); //primary
  root.style.setProperty('--topbar-font-color', '#ffffff'); //text on primary
  root.style.setProperty('--menubar-background-color', '#37464f'); //secondary
  root.style.setProperty('--menubar-font-color', '#ffffff'); //text on secondary
  root.style.setProperty('--button-background-color', '#4f5b62'); //secondary light
  root.style.setProperty('--button-highlight-color', '#37464f'); //secondary
  root.style.setProperty('--button-font-color', '#000000'); //text on secondary
  root.style.setProperty('--button-outline-color', '#000a12'); //primary dark
  root.style.setProperty('--taskbar-color', '#263238'); //primary
  sessionStorage.setItem('themeSelection.file', 'dark');
}

export const changeToPurpleTheme = () => {
  let root = document.documentElement;
  root.style.setProperty('--desktop-color', '#a094b7'); //secondary dark
  root.style.setProperty('--icon-font-color', '#000000'); //text on secondary
  root.style.setProperty('--app-background-color', '#fff7ff'); //secondary light
  root.style.setProperty('--app-outline-color', '#320b86'); //primary dark
  root.style.setProperty('--topbar-background-color', '#673ab7'); //primary
  root.style.setProperty('--topbar-font-color', '#ffffff'); //text on primary
  root.style.setProperty('--menubar-background-color', '#d1c4e9'); //secondary
  root.style.setProperty('--menubar-font-color', '#000000'); //text on secondary
  root.style.setProperty('--button-background-color', '#9a67ea'); //secondary light
  root.style.setProperty('--button-highlight-color', '#d1c4e9'); //secondary
  root.style.setProperty('--button-font-color', '#000000'); //text on secondary
  root.style.setProperty('--button-outline-color', '#320b86'); //primary dark
  root.style.setProperty('--taskbar-color', '#673ab7'); //primary
  sessionStorage.setItem('themeSelection.file', 'purple');
}

export const changeToGreenTheme = () => {
  let root = document.documentElement;
  root.style.setProperty('--desktop-color', '#75a478'); //secondary dark
  root.style.setProperty('--icon-font-color', '#000000'); //text on secondary
  root.style.setProperty('--app-background-color', '#d7ffd9'); //secondary light
  root.style.setProperty('--app-outline-color', '#00600f'); //primary dark
  root.style.setProperty('--topbar-background-color', '#388e3c'); //primary
  root.style.setProperty('--topbar-font-color', '#000000'); //text on primary
  root.style.setProperty('--menubar-background-color', '#a5d6a7'); //secondary
  root.style.setProperty('--menubar-font-color', '#000000'); //text on secondary
  root.style.setProperty('--button-background-color', '#6abf69'); //secondary light
  root.style.setProperty('--button-highlight-color', '#a5d6a7'); //secondary
  root.style.setProperty('--button-font-color', '#000000'); //text on secondary
  root.style.setProperty('--button-outline-color', '#00600f'); //primary dark
  root.style.setProperty('--taskbar-color', '#388e3c'); //primary
  sessionStorage.setItem('themeSelection.file', 'green');
}
